import axios from 'axios';
import { helperGetApiHeaders, axiosErrorHandler } from 'helpers/ApiHelper';
import { getEmailSubmissionBody, getEmailSubmissionUrl } from './EmailSubmissionFormHelpers';

export const SEND_EMAIL = 'SEND_EMAIL';

export function sendEmail({ email, accessToken, deviceId }) {
  const pathKey = 'emailCapture';
  const url = getEmailSubmissionUrl(pathKey);
  const body = getEmailSubmissionBody(email);
  const headers = helperGetApiHeaders({ pathKey, accessToken, deviceId });
  const request = axios.post(url, body, headers).catch(axiosErrorHandler);

  return {
    type: SEND_EMAIL,
    payload: request,
  };
}
